import { useTranslation } from 'react-i18next'

import env from 'env'
import { FC } from 'react'
import { ACheckboxV2 } from 'views/components/Analytics'

const currency = env.REACT_APP_CURRENCY_SYMBOL
const MATCH_MARGIN_MIN = 1000000

type Props = {
  value: string
  updateFilterState: (value: Record<string, number | undefined>) => void
}

export const MatchesMarginMinFilter: FC<Props> = ({ value, updateFilterState }) => {
  const { t } = useTranslation('dashboard')

  return (
    <ACheckboxV2
      id="marginMin"
      onChange={(e) => updateFilterState({ match_margin_min: e.target.checked ? MATCH_MARGIN_MIN : undefined })}
      checked={value ? JSON.parse(value) : undefined}
      label={`${t('marginFromMillion')} ${currency}`}
    />
  )
}
